export const faqs = [
    {
        question: "Is HouseSit Match safe to use?",
        answer: "Yes. Every member goes through our triple identity verification process before they can connect with homeowners or house sitters. We also offer optional police checks, transparent reviews, and real human support—so trust isn’t left to an algorithm alone.",
    },
    {
        question: "How does HouseSit Match verify house sitters?",
        answer: "We use three-factor identity verification for every member, with optional police checks for extra peace of mind. You can also review a sitter’s full profile and speak with them directly by video call before sharing any other contact details.",
    },
    {
        question: "Can I talk to a real person if I have a concern?",
        answer: "Yes—HouseSit Match is family-run, and our support team is reachable by phone or email. If something doesn’t feel right, we listen, investigate, and support both homeowners and sitters fairly rather than leaving you to sort it out alone.",
    },
    {
        question: "What happens if there’s a pet emergency during a sit?",
        answer: "Our house sitters have access to pet emergency guidance so they know exactly what to do if a pet becomes unwell or something unexpected happens—reducing stress for both the sitter and the homeowner while they’re away.",
    },
    {
        question: "Does HouseSit Match check reviews before I book a sit?",
        answer: "Yes. We maintain transparent, honest reviews from real members, and we hold a 4.9/5 rating on Trustpilot. You can see a sitter or homeowner’s history before committing, so there are no surprises going into a sit.",
    },
    {
        question: "Is HouseSit Match only for the UK, or does it work internationally?",
        answer: "HouseSit Match has an international community with members represented in more than 25 countries. Whether you’re a homeowner or sitter, our verification and support processes apply the same way wherever you’re based.",
    },
];
